import _ from 'lodash';

import { inject } from '../utils';
import GtmService from '../services/GtmService';

class GEMSService {
  constructor(apiFactory, session) {
    this.session = session;
    this.http = apiFactory('/gems');
    this.gtm = GtmService;
    this.gtm.dataLayer({
      action: 'initialize',
      label: 'App initizalization',
    });
  }

  async getGuests(type) {
    const affiliateId = this.session.getAffiliateId();
    const url = `/affiliates/${affiliateId}/guests/${type}`;
    const {
      data: {
        data,
      },
    } = await this.http.get(url);
    return data;
  }

  async getAllReservations() {
    const [
      checkedInGuests,
      dueInGuests,
      checkedOutGuests,
    ] = await Promise.all([
      this.getGuests('checked_in'),
      this.getGuests('due_in'),
      this.getGuests('checked_out'),
    ]);

    const reservations = [
      ...checkedInGuests,
      ...dueInGuests,
      ...checkedOutGuests,
    ];

    return reservations.map((item) => {
      const { attributes: reservation } = item;
      const room = _.get(reservation, 'locations[0].name', 'N/A');

      const name = [reservation.first_name, reservation.last_name].join(' ');
      return {
        ...item,
        attributes: {
          ...reservation,
          name,
          room,
        },
      };
    });
  }
}

inject(GEMSService, ['ApiFactory', 'SessionService', 'GtmService']);
export default GEMSService;



// WEBPACK FOOTER //
// ./src/services/GEMSService.js